import allRoles from './roles'

export const getParam = (roles, paramName) => roles.reduce((t, o) => {
  const role = allRoles[o]
  const roleParam = role && role[paramName]
  roleParam && Array.isArray(roleParam) && roleParam.forEach(o => !t.includes(o) && t.push(o))
  return t
}, [])

export default allRoles 